<template>
  <div>
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label">
      <b-field :label="label">
        <input v-show="false" v-model="video" />
      </b-field>
      <p v-if="!video">No video uploaded.</p>
      <CloudflareVideoPlayer
        v-if="video"
        :video-id="video"
      ></CloudflareVideoPlayer>
      <b-button v-if="video" size="is-small" @click="removeVideo"
        >Remove</b-button
      >
      <b-button
        size="is-small"
        @click="
          showUpload = !showUpload
          showUrlUpload = false
        "
        >{{ showUpload ? 'Hide Upload' : 'From File' }}</b-button
      >
      <b-button
        size="is-small"
        @click="
          showUrlUpload = !showUrlUpload
          showUpload = false
        "
        >{{ showUrlUpload ? 'Hide Upload' : 'From URL' }}</b-button
      >
    </ValidationProvider>
    <div v-if="showUrlUpload">
      <b-field label="Video URL">
        <b-input v-model="uploadUrl" type="url" />
      </b-field>
      <b-button
        :loading="uploadFromUrlLoading"
        @click="uploadFromUrl(uploadUrl)"
        >Upload from URL</b-button
      >
    </div>
    <b-upload
      v-if="showUpload"
      v-model="videoFile"
      accept="video/*"
      drag-drop
      :loading="showUploadLoading"
      @input="uploadVideo"
    >
      <section class="section">
        <div class="content has-text-centered">
          <p>
            <b-icon icon="upload" size="is-large"> </b-icon>
          </p>
          <p>
            Drop your file here or click to upload
          </p>
        </div>
      </section>
    </b-upload>
    <b-progress
      v-if="showUploadLoading"
      type="is-info"
      :value="showUploadProgress"
    ></b-progress>
  </div>
</template>

<script>
import UploadApi from '@/api/upload'
import EventBus from '@/eventbus'
import CloudflareVideoPlayer from '@/components/CloudflareVideoPlayer'

export default {
  name: 'UploadVideo',
  components: {
    CloudflareVideoPlayer
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showUpload: false,
      showUrlUpload: false,
      showUploadLoading: false,
      uploadUrl: null,
      uploadFromUrlLoading: false,
      videoFile: null,
      showUploadProgress: 0,
      video: null
    }
  },
  watch: {
    value(value) {
      this.video = value
    }
  },
  mounted() {
    if (this.value) {
      this.video = this.value
    } else {
      this.$emit('input', null)
    }
  },
  methods: {
    removeVideo() {
      this.video = null
      this.$emit('input', null)
    },
    uploadFromUrl(url) {
      let filename = url.split('/').pop()
      this.uploadFromUrlLoading = true
      UploadApi.uploadVideo(this.uploadUrl, filename).then(uploadResponse => {
        this.video = uploadResponse.videoId
        this.$emit('input', this.video)
        this.uploadFromUrlLoading = false
      })
    },
    uploadVideo(file) {
      this.showUploadLoading = true
      UploadApi.getPresignedLink({ file: file.name, bucket: 'videos' })
        .then(response => {
          EventBus.$on(file.name, progress => {
            this.showUploadProgress = progress / 2
          })
          UploadApi.uploadToS3(response, file)
            .then(() => {
              UploadApi.uploadVideo(
                response.final,
                response.filename,
                file.size,
                file.type
              ).then(uploadResponse => {
                this.video = uploadResponse.videoId
                this.$emit('input', this.video)
                this.showUpload = false
                this.showUploadLoading = false
                EventBus.$off(file.name)
              })
            })
            .catch(err => {
              console.log(err)
              this.$buefy.toast.open({
                message: `Error uploading ${this.label} (2)`,
                position: 'is-top',
                type: 'is-danger'
              })
              this.showUploadLoading = false
            })
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: `Error uploading ${this.label} (1)`,
            position: 'is-top',
            type: 'is-danger'
          })
          this.showUploadLoading = false
        })
    }
  }
}
</script>
